import axiosInstance from "./AxiosInstance";

export function getMedicineStarted(
  prescription_id,
  medicine_started,
  medicine_started_date
) {
  return axiosInstance.post("/servicecaller/MedicineStarted", {
    prescription_id,
    medicine_started,
    medicine_started_date,
  });
}

export function getPrescriptionExplained(
  prescription_id,
  prescription_explained,
  prescription_explained_date
) {
  return axiosInstance.post("/servicecaller/PrescriptionExplained", {
    prescription_id,
    prescription_explained,
    prescription_explained_date,
  });
}

export function getPrescriptionSummary(patient_id) {
  return axiosInstance.post("/servicecaller/summary", { patient_id });
}

export const getAnswerList = async (
  patientId,
  isImportant = "No",
  date = null
) => {
  try {
    const params = {
      patient_id: 1,
      is_important: isImportant,
      ...(date && { date: date }), // Only add date if it's provided
    };

    const response = await axiosInstance.post(`/admin/answerList`, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching answer list:", error);
    throw error;
  }
};

export function addReminder({ prescription_id,patient_id ,reminder_date, reminder_time }) {
  return axiosInstance.post("/servicecaller/addReminder", {
   prescription_id,patient_id,
    reminder_date,
    reminder_time,
  });
}

export function addFollowupDelay({ schedule_id, delay_days }) {
  return axiosInstance.post("/servicecaller/addFollowupDelay", {
    schedule_id,
    delay_days,
  });
}

export function getScheduledList(prescription_id) {
  return axiosInstance.post("/servicecaller/scheduledList", {
    prescription_id,
  });
}

export const generateFollowupId = async (prescription_id, patient_id) => {
  const response = await axiosInstance.post(
    `/servicecaller/generatefollowupId`,
    {
      prescription_id,
      patient_id,
    }
  );
  return response.data;
};

export const addFollowup = async (data) => {
  const response = await axiosInstance.post(`/servicecaller/addFollowup`, data);
  return response.data;
};

export const getFollowupList = async (prescription_id) => {
  const response = await axiosInstance.post(`/servicecaller/followupList`, {
    prescription_id,
  });
  return response.data;
};

export const addNote = async (noteData) => {
  const response = await axiosInstance.post(`/admin/addNote`, noteData);
  return response.data;
};

export const discardFollowupId = async (followup_id) => {
  const response = await axiosInstance.post(
    `/servicecaller/discardgeneratefollowupId`,
    {
      followup_id,
    }
  );
  return response.data;
};

export function sendScheduled(patient_id, prescription_id) {
  return axiosInstance.post("/servicecaller/sendScheduled", {
    patient_id,
    prescription_id,
  });
}